import React, { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';
import he from "he";
import axios from 'axios';
import { getAuthProfile, isEnabled, isFeautureEnabled, getSearchParams, isArray } from '../../services/utils/validation';
import { useLanguageRes } from '../../services/Context/LanguageContext';
import { useAccountSettings } from '../../services/Context/AccSettingContext';
import { useProfile } from '../../services/utils/profileContext';
import MessageNotification from '../../components/modules/message/MessageNotification';


const NavMenu = ({ home, profile }) => {

    const { account, accountSettings, accountModules } = useAccountSettings();
    const { getLanguageContent } = useLanguageRes();
    const { patientInfo } = useProfile();
    const location = useLocation();

    // Derived during render (not in an effect) so the header never paints a frame without its content.
    const navContent = useMemo(() => {
        const data = Array.isArray(account?.portalSettings) ? account.portalSettings.find((list) => list?.code == "HRC") : null;
        return data ? he.decode(DOMPurify.sanitize(data?.value)) : null;
    }, [account]);

    useEffect(() => {
        if (accountSettings && isArray(accountSettings)) {
            const lurSetting = accountSettings.find(x => x.settingCode === "LUR");
            const lurValue = lurSetting?.value;
            if (lurValue && lurValue !== "") {
                if (sessionStorage?.isAuth === "true") {
                    axios.get('extlogout/logout')
                        .then(response => {

                        })
                        .catch(error => {
                            if (error.response && error.response.status === 401) {
                                sessionStorage.setItem("isAuth", false);
                                window.location.href = lurValue;
                            } else {
                                console.error('Error:', error.message);
                            }
                        });
                }
            }
        }
    }, [location, accountSettings]);
    let showPreSignInButton = window.location.pathname == "/preconsultationform" ? getSearchParams("uid") ? true : false : true;

    // Get Started widget gates the dashboard icon only inside the intake flow (/service) — when
    // the account has the widget disabled, the icon must stay hidden there so patients can't jump
    // out of the booking flow to the dashboard. Outside the intake flow the icon is unaffected.
    const isGetStartedWidgetEnabled = isFeautureEnabled(accountModules, "GGT");
    // /profiledetail is also part of the intake flow when opened from the booking summary
    // (DoctorSummary.js carries the /service query string along); from the dashboard or visit
    // pages it is opened with only ?memberid= and stays outside the flow.
    const _flowParams = new URLSearchParams(location.search);
    const isIntakeProviderProfile = location.pathname === "/profiledetail" && ["spid", "serviceid", "brtype", "current"].some((p) => _flowParams.get(p));
    const isIntakeFlow = location.pathname === "/service" || location.pathname === "/services" || isIntakeProviderProfile;
    const showDashboardIcon = !isIntakeFlow || isGetStartedWidgetEnabled;
    return (
        <>
            <nav className="navbar nav-container d-lg-block justify-content-start bg-white px-3 py-2 ">
                <div className="d-flex align-items-center  w-100">
                    <div>
                        {account?.logo ? (
                            <>
                                {!showPreSignInButton ? <img src={`/doc/getimage?url=${encodeURIComponent(account?.logo)}`} height="70" alt="logo" /> :
                                    home?.url?.includes("https://") ? <a href={`${home?.url}`} className="navbar-brand">
                                        <img src={`/doc/getimage?url=${encodeURIComponent(account?.logo)}`} height="70" alt="logo" />
                                    </a> : <Link className="navbar-brand" to={`${home?.url}`}>
                                        <img src={`/doc/getimage?url=${encodeURIComponent(account?.logo)}`} height="70" alt="logo" />
                                    </Link>
                                }
                            </>)
                            : (
                                <>
                                    {home?.url?.includes("https://") ?
                                        <a href={`${home?.url}`} className="">
                                            <h3>{account?.name}</h3>
                                        </a> :
                                        <Link className="text-decoration-none text-dark" to={`${home?.url}`}>
                                            <h3>{account?.name}</h3>
                                        </Link>
                                    }
                                </>
                            )
                        }
                    </div>

                    <div className="d-flex flex-grow-1 justify-content-end align-items-center">

                        {isFeautureEnabled(accountModules, "MSG") &&
                            getAuthProfile.getProfileAuth() && (
                                <MessageNotification />
                            )}

                        <div className="d-none d-md-flex align-items-center" dangerouslySetInnerHTML={{ __html: navContent }}>

                        </div>
                    </div>

                    <div className="align-self-center">
                        {!getAuthProfile.getProfileAuth() && window.location.pathname !== "/security/login" && window.location.pathname != "/activateaccount" && isEnabled(accountSettings, "DUS", 0) && showPreSignInButton ?
                            <Link to="/security/login">
                                <button className="btn btn-primary px-4 rounded-pill">{getLanguageContent("signin")}</button>
                            </Link>
                            : ""}

                        {(profile?.resProfile?.firstName || patientInfo) && showDashboardIcon && (
                            <Link to="/dashboard" title="Dashboard">
                                <svg className="nav_icons" width="28" height="28" role="img"><use xlinkHref="#svg_dashboard" /></svg>
                            </Link>
                        )}

                    </div>
                </div>

            </nav>
        </>
    );
}

export default NavMenu;


